import { createUseStyles } from 'react-jss'
import { darkGrey, mediumGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  wrapper: {
    marginTop: 24
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16
  },
  title: {
    fontSize: 16,
    lineHeight: 1,
    fontWeight: 700
  },
  selectController: {
    fontSize: 14,
    color: mediumGrey,
    '&:hover': {
      color: darkGrey,
      cursor: 'pointer'
    }
  },
  checkbox: {
    marginTop: [10, '!important']
  }
})

export default useStyles
